import React from 'react';
import styles from './LoginError.module.scss';
import { ReactComponent as LoginError } from "@/assets/icons/LoginError.svg";

interface LoginErrorCardProps {
    onClose: () => void;
  }

export const LoginErrorCard: React.FC<LoginErrorCardProps> = ({ onClose }) => {
    return (
        <div className={styles.cardContainer}>
            <div className={styles.logoContainer}><LoginError /></div>
            <h2 className={styles.text}>Login Error!</h2>
            <p className={styles.subText}>
                Something went wrong.<br />
                Please try again later.
            </p>
            <button className={styles.button} onClick={onClose}>
                Close
            </button>
        </div>
    );
}
